import React, { useEffect, useState, useRef, useMemo } from "react";
import { CreateNewCp, GetCountries, getCountryCodeList, UpdateCp } from "../../../../../api/Api";
import Swal from "sweetalert2";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import "./EditCp.css";


const EditCp = ({ setEditCpModal, editData, getAllData, getCount }) => {
  const [createCpForm, setCreateCpForm] = useState({
    firstName: editData?.firstName || "",
    lastName: editData?.lastName || "",
    emailId: editData?.email || "",
    // username: "",
    // password: "",
    mobileNumber: editData?.mobileNo || "",
    country: "",
    operator: "",

    companyName: editData?.cpDetailsList[0]?.companyName || "",
    companyCin: editData?.cpDetailsList[0]?.companyCin || "",
    streetAddress: editData?.cpDetailsList[0]?.companyAddress || "",
    cpnyPincode: editData?.cpDetailsList[0]?.zipcode || "",
    cpnyCity: editData?.cpDetailsList[0]?.city || "",
    cpnyState: editData?.cpDetailsList[0]?.state || "",
    cpnyCountry: editData?.cpDetailsList[0]?.country || "",

    businessContactPerson:
      editData?.cpDetailsList[0]?.businessContactPerson || "",
    businessContactEmail:
      editData?.cpDetailsList[0]?.businessContactEmail || "",
    businessContactMobile:
      editData?.cpDetailsList[0]?.businessContactNumber || "",

    financeContactPerson:
      editData?.cpDetailsList[0]?.financeContactPerson || "",
    financeContactEmail: editData?.cpDetailsList[0]?.financeContactEmail || "",
    financeContactMobile:
      editData?.cpDetailsList[0]?.financeContactNumber || "",
  });
  console.log("resedit",editData?.cpDetailsList[0]?.businessContactNumber);
  const [loaders, setLoaders] = useState({
    countryLoader: false,
  });
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const dropdownRef = useRef(null);
  const [operatorList, setOperatorList] = useState([]);
  console.log("operatorList", operatorList);
  const [error, setError] = useState(false);

  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  const phoneRegex = /^[6-9]\d{9}$/;

  const [selectedBusinessCountry, setSelectedBusinessCountry] = useState(null);
  const [showBusinessCountryDropdown, setShowBusinessCountryDropdown] = useState(false);
  const [searchBusinessCountry, setSearchBusinessCountry] = useState("");
  const businessDropdownRef = useRef(null);

  const [selectedFinanceCountry, setSelectedFinanceCountry] = useState(null);
  const [showFinanceCountryDropdown, setShowFinanceCountryDropdown] = useState(false);
  const [searchFinanceCountry, setSearchFinanceCountry] = useState("");
  const financeDropdownRef = useRef(null);

  // Filter countries with null checks
  const filteredBusinessCountries = useMemo(() => {
    return (countryList || []).filter(country => {
      if (!country) return false;
      const searchLower = searchBusinessCountry.toLowerCase();
      return (
        country.nicename?.toLowerCase().includes(searchLower) ||
        country.phonecode?.toString().includes(searchBusinessCountry)
      );
    });
  }, [countryList, searchBusinessCountry]);

  // Add this helper function at the top level
  const extractPhoneDetails = (fullNumber, countries) => {
    if (!fullNumber || !countries?.length) return { country: null, number: '' };

    const cleanNumber = fullNumber.replace(/^\+/, '');

    // Sort countries by phonecode length (descending) to match longer codes first
    const sortedCountries = [...countries].sort((a, b) =>
      String(b.phonecode).length - String(a.phonecode).length
    );

    for (const country of sortedCountries) {
      const phoneCode = String(country.phonecode);
      if (cleanNumber.startsWith(phoneCode)) {
        const number = cleanNumber.slice(phoneCode.length);
        if (number.length === country.msisdnLength) {
          return { country, number };
        }
      }
    }

    return { country: null, number: cleanNumber };
  };

  // Update the useEffect for business contact initialization
  useEffect(() => {
    if (!countryList?.length) return;

    const businessNumber = editData?.cpDetailsList?.[0]?.businessContactNumber;
    if (businessNumber) {
      const { country, number } = extractPhoneDetails(businessNumber, countryList);
      if (country) {
        setSelectedBusinessCountry(country);
        setCreateCpForm(prev => ({
          ...prev,
          businessContactMobile: number
        }));
      }
    }
  }, [countryList, editData]);

  useEffect(() => {
    const initializeFinanceContact = () => {
      if (!countryList?.length) return;

      const financeNumber = editData?.cpDetailsList?.[0]?.financeContactNumber;

      if (financeNumber) {
        const cleanNumber = financeNumber.replace(/^\+/, '');

        // Find country by phone code with safe checks
        const matchingCountry = countryList.find(country => {
          if (!country?.phonecode) return false;
          return cleanNumber.startsWith(country.phonecode.toString());
        });

        if (matchingCountry) {
          setSelectedFinanceCountry(matchingCountry);
          const numberWithoutCode = cleanNumber.slice(matchingCountry.phonecode.toString().length);
          setCreateCpForm(prev => ({
            ...prev,
            financeContactMobile: numberWithoutCode
          }));
        } else {
          // Default to India if no match found
          const india = countryList.find(country => country?.iso === "IN");
          if (india) {
            setSelectedFinanceCountry(india);
          }
        }
      } else {
        // Set India as default for new entries
        const india = countryList.find(country => country?.iso === "IN");
        if (india) {
          setSelectedFinanceCountry(india);
        }
      }
    };

    initializeFinanceContact();
  }, [countryList, editData]);

  // create cp
  const handleSubmit = async (e) => {
    console.log("errorrr", error);
    e.preventDefault();
    const {
      firstName,
      lastName,
      emailId,
      //   username,
      //   password,
      mobileNumber,
        // country,
        // operator,

      companyName,
      companyCin,
      streetAddress,
      cpnyPincode,
      cpnyCity,
      cpnyState,
      cpnyCountry,

      businessContactPerson,
      businessContactEmail,
      businessContactMobile,

      financeContactPerson,
      financeContactEmail,
      financeContactMobile,
    } = createCpForm;
    if (
      !firstName ||
      !lastName ||
      !emailId ||
      !emailRegex.test(emailId) ||
      //   !username ||
      //   !password ||
      //   !pass.test(password) ||
      !mobileNumber
      //  ||
      // (mobileNumber && !phoneRegex.test(mobileNumber))
       ||
      // !country ||
      // !operator ||
      !companyName ||
      !companyCin ||
      !streetAddress ||
      !cpnyPincode ||
      !cpnyCity ||
      !cpnyState ||
      !cpnyCountry ||
      !businessContactPerson ||
      !businessContactEmail ||
      !emailRegex.test(businessContactEmail) ||
      !businessContactMobile
      //  ||
      // !phoneRegex.test(businessContactMobile) 
      ||
      !financeContactPerson ||
      !financeContactEmail ||
      !emailRegex.test(financeContactEmail) ||
      !financeContactMobile 
      // ||
      // !phoneRegex.test(financeContactMobile)
    ) {
      setError(true);
    } else {
      setError(false);
      let payload = {
        userId: getFromLocalStorage("userData")?.id,
        id: editData?.id,
        firstName: firstName,
        lastName: lastName,
        email: emailId,
        // username: username,
        // passwd: password,
        mobileNo: selectedCountry
          ? `+${selectedCountry.phonecode}${mobileNumber}`
          : mobileNumber,
        // countryName: country,
        // operatorNameList: [Number(operator)],
        cpDetailsList: [
          {
            companyName: companyName,
            companyAddress: streetAddress,
            companyCin: companyCin,
            streetAddress: streetAddress,
            city: cpnyCity,
            state: cpnyState,
            country: cpnyCountry,
            zipcode: cpnyPincode,
            companyRegistrationDoc: "",

            businessContactPerson: businessContactPerson,
            businessContactNumber: selectedBusinessCountry
              ? `+${selectedBusinessCountry.phonecode}${businessContactMobile}`
              : businessContactMobile,
            businessContactEmail: businessContactEmail,

            financeContactPerson: financeContactPerson,
            financeContactNumber: selectedFinanceCountry
              ? `+${selectedFinanceCountry.phonecode}${financeContactMobile}`
              : financeContactMobile,
            financeContactEmail: financeContactEmail,
          },
        ],
      };
      console.log("responseCreateCp", payload);
      const response = await UpdateCp(payload);
      if (response?.statusDescription?.status == 200) {
        getAllData();
        getCount();
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
        setEditCpModal(false);
      } else {
        Swal.fire({
          icon: "info",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
      }
    }
  };
  console.log("errorrr", error);
  // const getCountriesAndOperators = async () => {
  //   setLoaders((prev) => ({ ...prev, countryLoader: true }));
  //   const response = await GetCountries();
  //   if (response?.statusDescription?.status == 200) {
  //     setCountryList(response?.countryResponseList);
  //   } else {
  //     setCountryList([]);
  //   }
  //   setLoaders((prev) => ({ ...prev, countryLoader: false }));
  // };

  // useEffect(() => {
  //   getCountriesAndOperators();
  // }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountryCodeList();
        if (response?.countryList) {
          setCountryList(response.countryList);
          // Find and set India as default
          const india = response.countryList.find(
            (country) => country.iso === "IN"
          );
          if (india) {
            // setSelectedCountry(india);
          }
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (createCpForm?.mobileNumber && countryList?.length > 0) {
      const cleanNumber = createCpForm.mobileNumber.replace(/^\+/, '');

      // Find country by phone code with safe checks
      const matchingCountry = countryList.find(country =>
        country?.phonecode && cleanNumber.startsWith(country.phonecode.toString())
      );

      if (matchingCountry) {
        setSelectedCountry(matchingCountry);
        // Remove country code from the number
        const numberWithoutCode = cleanNumber.slice(matchingCountry.phonecode.toString().length);
        setCreateCpForm(prev => ({
          ...prev,
          mobileNumber: numberWithoutCode
        }));
      }
    }
  }, [countryList, createCpForm?.mobileNumber]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (businessDropdownRef.current && !businessDropdownRef.current.contains(event.target)) {
        setShowBusinessCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (financeDropdownRef.current && !financeDropdownRef.current.contains(event.target)) {
        setShowFinanceCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  console.log("bbbbileNumber", editData?.cpDetailsList?.[0]?.businessContactNumber);
console.log("countryListtt",countryList);
  return (
    <form class="form-horizontal" onSubmit={handleSubmit}>
      <div className="card mt-4 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Personal Information</span>
        <div class="row mb-1 pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                First Name<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.firstName ? "is-invalid" : ""
                  }`}
                maxlength="100"
                name="firstName"
                placeholder="First Name"
                autocomplete="FirstName"
                value={createCpForm.firstName}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.firstName && (
                <div class="invalid-feedback d-block error">
                  <div>First Name is required.</div>
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Last Name<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.lastName ? "is-invalid" : ""
                  }`}
                autocomplete="LastName"
                placeholder="Last Name"
                maxlength="30"
                name="lastName"
                value={createCpForm.lastName}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    lastName: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.lastName && (
                <div class="invalid-feedback d-block error">
                  <div>Last Name is required.</div>
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Email Id<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.emailId ? "is-invalid" : ""
                  }`}
                autocomplete="EmailId"
                placeholder="Email Id"
                maxlength="70"
                name="emailId"
                value={createCpForm.emailId}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    emailId: e.target.value,
                  }))
                }
              />
              {error &&
                (!createCpForm.emailId ||
                  !emailRegex.test(createCpForm.emailId)) && (
                  <div className="invalid-feedback d-block error">
                    {!createCpForm.emailId
                      ? "Please enter an email id"
                      : createCpForm.emailId &&
                        !emailRegex.test(createCpForm.emailId)
                        ? "Please enter a valid email id"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          {console.log("selectedCountry111",selectedCountry)}
          <div class="form-group col-sm-3">
            {/* <div className="form-group"> */}
              <label className="">
                Mobile<sup className="text-danger">*</sup>
              </label>
              <div className="phone-input-container" ref={dropdownRef}>
                <div
                  className="phone-select"
                  onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                >
                  {selectedCountry ? (
                    <>
                      <img
                        src={`https://flagcdn.com/w20/${selectedCountry.iso.toLowerCase()}.png`}
                        alt={selectedCountry.nicename}
                        className="flag-icon"
                      />
                      <span className="country-code">
                        +{selectedCountry.phonecode}
                      </span>
                      <i className="fas fa-chevron-down arrow-icon"></i>
                    </>
                  ) : (
                    <span>Select Country</span>
                  )}
                </div>
                {console.log("selectedCountry",selectedCountry?.msisdnLength)}
                <input
                  type="text"
                  className={`form-control mobile-input ${error &&
                      (!createCpForm.mobileNumber ||
                        createCpForm.mobileNumber.length !== selectedCountry?.msisdnLength)
                      ? "is-invalid"
                      : ""
                    }`}
                  placeholder={`Enter ${selectedCountry?.msisdnLength || 10} digit number`}
                  // maxLength={selectedCountry?.msisdnLength || 10}
                  minLength={selectedCountry?.msisdnLength || 0}
                  maxLength={selectedCountry?.msisdnLength || 0}
                  value={createCpForm.mobileNumber || ''}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (
                      selectedCountry &&
                      value.length <= selectedCountry.msisdnLength
                    ) {
                      setCreateCpForm((prev) => ({
                        ...prev,
                        mobileNumber: value,
                      }));
                    }
                  }}
                />

                {showCountryDropdown && (
                  <div className="country-dropdown">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search country..."
                      value={searchCountry}
                      onChange={(e) => setSearchCountry(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div className="country-list">
                      {(countryList || [])
                        .filter(country =>
                          country?.nicename?.toLowerCase().includes(searchCountry.toLowerCase()) ||
                          country?.phonecode?.toString().includes(searchCountry)
                        )
                        .map((country) => (
                          <div
                            key={country.id}
                            className={`country-item ${selectedCountry?.id === country.id ? 'active' : ''
                              }`}
                            onClick={() => {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                              setSearchCountry("");
                              setCreateCpForm((prev) => ({
                                ...prev,
                                mobileNumber: "",
                              }));
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${country.iso.toLowerCase()}.png`}
                              alt={country.nicename}
                              className="flag-icon"
                            />
                            <span className="country-name">{country.nicename}</span>
                            <span className="country-code">
                              +{country.phonecode}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
              {error &&
                (!createCpForm.mobileNumber ||
                  createCpForm.mobileNumber.length !== selectedCountry?.msisdnLength) && (
                  <div className="invalid-feedback d-block">
                    {!createCpForm.mobileNumber
                      ? "Please enter a mobile number"
                      : `Please enter a valid ${selectedCountry?.msisdnLength}-digit mobile number`}
                  </div>
                )}
            {/* </div> */}
          </div>
          
        </div>

        {/* <div class="row mb-1  row_div px-4">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="font-weight-bold">Country Name</label>
              <input
                type="text"
                class="form-control"
                value={editData?.cpCountryList?.[0]?.countryName || ""}
                readOnly
                placeholder="Country Name"
              />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="font-weight-bold">Operator</label>
              <input
                type="text"
                class="form-control"
                value={
                  editData?.cpCountryList?.[0]?.cpOperatorList?.[0]
                    ?.operatorName || ""
                }
                readOnly
                placeholder="Operator"
              />
            </div>
          </div>
        </div> */}
      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Company Information</span>
        <div class="row mb-1 pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Company Name<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.companyName ? "is-invalid" : ""
                  }`}
                autocomplete="companyAdd"
                placeholder="Company Address"
                maxlength={100}
                name="companyAdd"
                value={createCpForm.companyName}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    companyName: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.companyName && (
                <div class="invalid-feedback d-block error">
                  Please enter a company name
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Company Cin<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.companyCin ? "is-invalid" : ""
                  }`}
                autocomplete="companyCin"
                placeholder="Company Cin"
                maxlength={30}
                name="companyCin"
                value={createCpForm.companyCin}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    companyCin: e.target.value,
                  }))
                }
              />
              {error && !createCpForm.companyCin && (
                <div class="invalid-feedback d-block error">
                  Please enter a company cin
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Street Address<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.streetAddress ? "is-invalid" : ""
                  }`}
                autocomplete="streetAddress"
                placeholder="Street Address"
                maxlength={30}
                name="streetAddress"
                value={createCpForm.streetAddress}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    streetAddress: e.target.value,
                  }))
                }
              />
              {error && !createCpForm.streetAddress && (
                <div class="invalid-feedback d-block error">
                  Please enter a street address
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Pincode<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyPincode ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyPincode"
                placeholder="Pincode"
                maxlength={30}
                name="cpnyPincode"
                value={createCpForm.cpnyPincode}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyPincode: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (
                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyPincode && (
                <div class="invalid-feedback d-block error">
                  Please enter a pincode
                </div>
              )}
            {/* </div> */}
          </div>
        </div>

        <div class="row mb-1 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                City<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyCity ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyCity"
                placeholder="City"
                maxlength={30}
                name="cpnyCity"
                value={createCpForm.cpnyCity}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyCity: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyCity && (
                <div class="invalid-feedback d-block error">
                  Please enter a city
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                State<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyState ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyState"
                placeholder="State"
                maxlength={30}
                name="cpnyState"
                value={createCpForm.cpnyState}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyState: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyState && (
                <div class="invalid-feedback d-block error">
                  Please enter a state
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Country <sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyCountry ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyCountry"
                placeholder="Country"
                maxlength={30}
                name="cpnyCountry"
                value={createCpForm.cpnyCountry}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyCountry: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyCountry && (
                <div class="invalid-feedback d-block error">
                  Please enter a country
                </div>
              )}
            {/* </div> */}
          </div>
        </div>

      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Business Information</span>
        <div class="row mb-1 pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                 Contact person<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.businessContactPerson ? "is-invalid" : ""
                  }`}
                autocomplete="businessContactPerson"
                placeholder="Business Contact Person"
                maxlength={30}
                name="businessContactPerson"
                value={createCpForm.businessContactPerson}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    businessContactPerson: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.businessContactPerson && (
                <div class="invalid-feedback d-block error">
                  Please enter a business contact person
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                 Contact Email<sup class="text-danger">*</sup>
              </label>
              <input
                type="email"
                class={`form-control ${error &&
                    (!createCpForm.businessContactEmail ||
                      !emailRegex.test(createCpForm.businessContactEmail))
                    ? "is-invalid"
                    : ""
                  }`}
                autocomplete="BusContactMail"
                placeholder="Business Contact Email"
                maxlength={100}
                name="BusContactMail"
                value={createCpForm.businessContactEmail}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    businessContactEmail: e.target.value,
                  }))
                }
              />
              {error &&
                (!createCpForm.businessContactEmail ||
                  !emailRegex.test(createCpForm.businessContactEmail)) && (
                  <div class="invalid-feedback d-block error">
                    {!createCpForm.businessContactEmail
                      ? "Please enter a business contact email"
                      : createCpForm.businessContactEmail &&
                        !emailRegex.test(createCpForm.businessContactEmail)
                        ? "Please enter a valid business contact email"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-4">
          {/* <div className="form-group"> */}
            <label>
              Contact Number<sup className="text-danger">*</sup>
            </label>
            <div className="phone-input-container" ref={businessDropdownRef}>
              <div
                className="phone-select"
                onClick={() => setShowBusinessCountryDropdown(!showBusinessCountryDropdown)}
              >
                {selectedBusinessCountry ? (
                  <>
                    <img
                      src={`https://flagcdn.com/w20/${selectedBusinessCountry.iso?.toLowerCase()}.png`}
                      alt={selectedBusinessCountry.nicename || ''}
                      className="flag-icon"
                    />
                    <span className="country-code">
                      +{selectedBusinessCountry.phonecode}
                    </span>
                    <i className="fas fa-chevron-down arrow-icon"></i>
                  </>
                ) : (
                  <span>Select Country</span>
                )}
              </div>

              <input
                type="text"
                className={`form-control mobile-input ${
                  error &&
                  (!createCpForm.businessContactMobile ||
                    createCpForm.businessContactMobile.length !== selectedBusinessCountry?.msisdnLength)
                    ? "is-invalid"
                    : ""
                }`}
                placeholder={`Enter ${selectedBusinessCountry?.msisdnLength || ''} digit number`}
                // maxLength={selectedBusinessCountry?.msisdnLength || 0}
                minLength={selectedBusinessCountry?.msisdnLength || 0}
                maxLength={selectedBusinessCountry?.msisdnLength || 0}
                value={createCpForm.businessContactMobile || ''}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (selectedBusinessCountry && value.length <= selectedBusinessCountry.msisdnLength) {
                    setCreateCpForm(prev => ({
                      ...prev,
                      businessContactMobile: value,
                    }));
                  }
                }}
                disabled={!selectedBusinessCountry}
              />

              {showBusinessCountryDropdown && (
                <div className="country-dropdown">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search country..."
                    value={searchBusinessCountry}
                    onChange={(e) => setSearchBusinessCountry(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    minLength={selectedBusinessCountry?.msisdnLength || 0}
                    maxLength={selectedBusinessCountry?.msisdnLength || 0}
                  />
                  <div className="country-list">
                    {filteredBusinessCountries.map((country) => (
                      <div
                        key={country.id}
                        className={`country-item ${
                          selectedBusinessCountry?.id === country.id ? 'active' : ''
                        }`}
                        onClick={() => {
                          setSelectedBusinessCountry(country);
                          setShowBusinessCountryDropdown(false);
                          setSearchBusinessCountry("");
                          setCreateCpForm(prev => ({
                            ...prev,
                            businessContactMobile: "",
                          }));
                        }}
                      >
                        <img
                          src={`https://flagcdn.com/w20/${country.iso?.toLowerCase()}.png`}
                          alt={country.nicename || ''}
                          className="flag-icon"
                        />
                        <span className="country-name">{country.nicename}</span>
                        <span className="country-code">+{country.phonecode}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {error &&
              (!createCpForm.businessContactMobile ||
                createCpForm.businessContactMobile.length !== selectedBusinessCountry?.msisdnLength) && (
                <div className="invalid-feedback d-block">
                  {!createCpForm.businessContactMobile
                    ? "Please enter a business contact number"
                    : `Please enter a valid ${selectedBusinessCountry?.msisdnLength}-digit number`}
                </div>
              )}
          {/* </div> */}
        </div>
          {/* <div class="col-sm-3">
            <div class="form-group">
              <label>
                 Contact Number<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error &&
                    (!createCpForm.businessContactMobile ||
                      !phoneRegex.test(createCpForm.businessContactMobile))
                    ? "is-invalid"
                    : ""
                  }`}
                autocomplete="BusContactNumber"
                placeholder="Business Contact Number"
                maxlength={10}
                name="BusContactNumber"
                value={createCpForm.businessContactMobile}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    businessContactMobile: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (
                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              {error &&
                (!createCpForm.businessContactMobile ||
                  !phoneRegex.test(createCpForm.businessContactMobile)) && (
                  <div class="invalid-feedback d-block error">
                    {!createCpForm.businessContactMobile
                      ? "Please enter a business contact number"
                      : createCpForm.businessContactMobile &&
                        !phoneRegex.test(createCpForm.businessContactMobile)
                        ? "Please enter a valid business contact number"
                        : ""}
                  </div>
                )}
            </div>
          </div> */}
        </div>
      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Finance Information</span>
        <div class="row mb-1 pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                 Contact Person<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.financeContactPerson ? "is-invalid" : ""
                  }`}
                autocomplete="financeContactPerson"
                placeholder="Finance Contact Person"
                maxlength={30}
                name="financeContactPerson"
                value={createCpForm.financeContactPerson}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    financeContactPerson: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.financeContactPerson && (
                <div class="invalid-feedback d-block error">
                  Please enter a finance contact person
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                 Contact Email<sup class="text-danger">*</sup>
              </label>
              <input
                type="email"
                class={`form-control ${error &&
                    (!createCpForm.financeContactEmail ||
                      !emailRegex.test(createCpForm.financeContactEmail))
                    ? "is-invalid"
                    : ""
                  }`}
                autocomplete="FinanceContactEmail"
                placeholder="Finance Contact Email"
                maxlength={100}
                name="FinanceContactEmail"
                value={createCpForm.financeContactEmail}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    financeContactEmail: e.target.value,
                  }))
                }
              />
              {error &&
                (!createCpForm.financeContactEmail ||
                  !emailRegex.test(createCpForm.financeContactEmail)) && (
                  <div class="invalid-feedback d-block error">
                    {!createCpForm.financeContactEmail
                      ? "Please enter a finance contact email"
                      : createCpForm.financeContactEmail &&
                        !emailRegex.test(createCpForm.financeContactEmail)
                        ? "Please enter a valid finance contact email"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-4">
          {/* <div className="form-group"> */}
            <label>
              Contact Number<sup className="text-danger">*</sup>
            </label>
            <div className="phone-input-container" ref={financeDropdownRef}>
              <div
                className="phone-select"
                onClick={() => setShowFinanceCountryDropdown(!showFinanceCountryDropdown)}
              >
                {selectedFinanceCountry ? (
                  <>
                    <img
                      src={`https://flagcdn.com/w20/${selectedFinanceCountry.iso.toLowerCase()}.png`}
                      alt={selectedFinanceCountry.nicename}
                      className="flag-icon"
                    />
                    <span className="country-code">
                      +{selectedFinanceCountry.phonecode}
                    </span>
                    <i className="fas fa-chevron-down arrow-icon"></i>
                  </>
                ) : (
                  <span>Select Country</span>
                )}
              </div>

              <input
                type="text"
                className={`form-control mobile-input ${
                  error &&
                  (!createCpForm.financeContactMobile ||
                    createCpForm.financeContactMobile.length !== selectedFinanceCountry?.msisdnLength)
                    ? "is-invalid"
                    : ""
                }`}
                placeholder={`Enter ${selectedFinanceCountry?.msisdnLength || 10} digit number`}
                // maxLength={selectedFinanceCountry?.msisdnLength || 10}
                minLength={selectedFinanceCountry?.msisdnLength || 0}
                maxLength={selectedFinanceCountry?.msisdnLength || 0}
                value={createCpForm.financeContactMobile || ''}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (
                    selectedFinanceCountry &&
                    value.length <= selectedFinanceCountry.msisdnLength
                  ) {
                    setCreateCpForm((prev) => ({
                      ...prev,
                      financeContactMobile: value,
                    }));
                  }
                }}
              />

              {showFinanceCountryDropdown && (
                <div className="country-dropdown">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search country..."
                    value={searchFinanceCountry}
                    onChange={(e) => setSearchFinanceCountry(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div className="country-list">
                    {countryList
                      .filter(country => 
                        country.nicename.toLowerCase().includes(searchFinanceCountry.toLowerCase()) ||
                        country.phonecode.toString().includes(searchFinanceCountry)
                      )
                      .map((country) => (
                        <div
                          key={country.id}
                          className={`country-item ${
                            selectedFinanceCountry?.id === country.id ? 'active' : ''
                          }`}
                          onClick={() => {
                            setSelectedFinanceCountry(country);
                            setShowFinanceCountryDropdown(false);
                            setSearchFinanceCountry("");
                            setCreateCpForm((prev) => ({
                              ...prev,
                              financeContactMobile: "",
                            }));
                          }}
                        >
                          <img
                            src={`https://flagcdn.com/w20/${country.iso.toLowerCase()}.png`}
                            alt={country.nicename}
                            className="flag-icon"
                          />
                          <span className="country-name">{country.nicename}</span>
                          <span className="country-code">
                            +{country.phonecode}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
            {error &&
              (!createCpForm.financeContactMobile ||
                createCpForm.financeContactMobile.length !== selectedFinanceCountry?.msisdnLength) && (
                <div className="invalid-feedback d-block">
                  {!createCpForm.financeContactMobile
                    ? "Please enter a finance contact number"
                    : `Please enter a valid ${selectedFinanceCountry?.msisdnLength}-digit mobile number`}
                </div>
              )}
          {/* </div> */}
        </div>
          {/* <div class="col-sm-3">
            <div class="form-group">
              <label>
                 Contact Number<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error &&
                    (!createCpForm.financeContactMobile ||
                      !phoneRegex.test(createCpForm.financeContactMobile))
                    ? "is-invalid"
                    : ""
                  }`}
                autocomplete="financeContactNum"
                placeholder="Finance Contact Number"
                maxlength={10}
                name="financeContactNum"
                value={createCpForm.financeContactMobile}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    financeContactMobile: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (
                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              {error &&
                (!createCpForm.financeContactMobile ||
                  !phoneRegex.test(createCpForm.financeContactMobile)) && (
                  <div class="invalid-feedback d-block error">
                    {!createCpForm.financeContactMobile
                      ? "Please enter a finance contact number"
                      : createCpForm.financeContactMobile &&
                        !phoneRegex.test(createCpForm.financeContactMobile)
                        ? "Please enter a valid finance contact number"
                        : ""}
                  </div>
                )}
            </div>
          </div> */}
        </div>
      </div>
      <div class="modal-footer pb-0 border-0 justify-content-between  mx-0 px-0">
        <button
          type="button"
          class="btn btn-danger btn-raised m-0"
          data-dismiss="modal"
          onClick={() => {
            setEditCpModal(false);
            setError(false);
            setCreateCpForm({
              firstName: "",
              lastName: "",
              emailId: "",
              password: "",
              mobileNumber: "",
              companyName: "",
              companyCin: "",
              streetAddress: "",
              city: "",
              state: "",
              country: "",
              businessContactPerson: "",
              businessContactEmail: "",
              businessContactMobile: "",
              financeContactPerson: "",
              financeContactEmail: "",
              financeContactMobile: "",
              operator: "",
            });
          }}
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-primary btn-raised m-0">
          Submit
        </button>
      </div>
    </form>
  );
};

export default EditCp;
